import styled from 'styled-components'

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${({ theme }) => theme.app.backdropStyle};
  display: flex;
  align-items: ${({ isMobile }) => (isMobile ? 'end' : 'center')};
  justify-content: center;
  z-index: 999;
`
const ModalStyle = styled.div`
  background: ${({ theme }) => theme.app.background};
  color: ${({ theme }) => theme.app.text};
  border-radius: ${({ isMobile }) => (isMobile ? '24px 24px 0 0' : '24px')};
  padding: ${({ isMobile }) => (isMobile ? '32px 21px 0px 21px' : '32px 40px')};
  width: ${({ isMobile }) => (isMobile ? '100%' : '50vw')};
  max-width: 560px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.2);
  text-align: start;
  border: 1px solid #cccccc;
`

const SocialAppWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow-x: scroll;
  overflow-y: hidden;
  gap: 1rem;
  padding-bottom: ${({ isMobile }) => (isMobile ? '32px' : '0')};
`

const ImageWrapper = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.app.border};
  object-fit: cover;
`
const LinkWrapper = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.app.upload};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.app.border};
`
const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid #333;
  border-top: 3px solid #00b8f8;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const TextWrapper = styled.div`
  margin-top: 5px;
  font-size: 12px;
  width: max-content;
  min-width: 56px;
  text-align: center;
  color: ${({ theme }) => theme.app.iconlabel};
`
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
`
const Header = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.app.text};
`
export {
  Backdrop,
  ModalStyle,
  IconWrapper,
  ImageWrapper,
  TextWrapper,
  Header,
  SocialAppWrapper,
  LoadingSpinner,
  SpinnerWrapper,
  LinkWrapper
}
